// extracted by mini-css-extract-plugin
export default {"container":"DashboardSkeleton_container__cjqBG","header":"DashboardSkeleton_header__WMjC7","textWithIcon":"DashboardSkeleton_textWithIcon__-oYMC"};